/**
 * ShippingListContainer
 * --
 */
import React from 'react';
import { useUserStack } from 'store';
import ShippingList from 'routes/admin.routes/admin.orders/ShippingList';

const ShippingListContainer = () => {
  /* ===== ROUTE ===== */
  const userInfo = useUserStack();
  /* ===== PROPS ===== */
  /* ===== STATE ===== */
  /* ===== VARIABLE ===== */
  /* ===== FUNCTION ===== */
  /* ===== HOOKS ===== */
  /* ===== RENDER ===== */
  return (
    <>
      <ShippingList
        permission={userInfo.type}
        defaultShopId={userInfo.shop_information_id}
      />
    </>
  );
};

export default ShippingListContainer;
